/** @format */

import { Bounce, toast } from "react-toastify";
import axios from "axios";
import { BASEURL, toastStyle } from "../../Utils";
import axiosInterceptorInstance from "../../Interceptor";



const ApiInstance = async (
  endpoint,
  method,
  body,
  thunkAPI,
  query,
) => {

  const state = thunkAPI.getState();
  const toastApi = ['get-products']
  const couponApi = ['get-coupon']
  try {
    let res = await axiosInterceptorInstance.request({
      method: method,
      url: `${BASEURL}${endpoint}${query ? query : ""}`,
      data: body ? body : null,
    });
    console.log(res, "res")
    if (couponApi.includes(endpoint)) {
      toast.success("Coupon Applied Successfully", toastStyle)
    }
    if (toastApi.includes(endpoint) && res.data?.message == 'error') {
      toast.success("No Product Found", toastStyle)
      return thunkAPI.fulfillWithValue(null)

    }
    return thunkAPI.fulfillWithValue(res.data)
  } catch (error) {
    if (couponApi.includes(endpoint)) {
      toast.error(error?.response?.data?.message ||
        "Something went wrong", toastStyle)
    }
    console.log(error, "error----error")
    return thunkAPI.rejectWithValue("Something went wrong");
  }
};

export default ApiInstance;
